export enum AnomalySourceType {
  DONATION = 'Donation',
}
